export default "__VITE_ASSET__e2a859e7__"